import { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FlightFooterRow from "./FlightFooterRow";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  Collapse,
  ConfigProvider,
  Descriptions,
  Divider,
  Select,
  Skeleton,
  Tabs,
  Badge,
  Space,
  Typography,
  Tooltip,
} from "antd";
import FlightsFooter from "./FlightsFooter";
import FlightSvg from "../../assets/images/filters/Flights.svg";
import { useSearch } from "../../contexts/SearchContext";
import "./Index.scss";
import { useSelectedResult } from "../../contexts/SelectedResultContext";
import { useAppContext } from "../../contexts/AppContext";
import {
  SwitcherOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { PiSuitcaseRolling } from "react-icons/pi";
import { IoInformationCircleOutline } from "react-icons/io5";
import { SlHandbag } from "react-icons/sl";
import { convertPrice } from "../../services/currencyService";
import AirlineDisplay from "../AirlineDisplay/Index";
import { FaPlane } from "react-icons/fa";

const { Title, Text } = Typography;

const FlightSelection = ({
  linkedFlightsData = undefined,
  loadingLinkedFlights,
  isCard,
  isCollaped,
  isSelectable,
  title = undefined,
  inTourObject = false, // New prop to identify tour object context
  isCompact = false, // New prop for compact display in dynamic packages
  includeTitle = true, // New prop to control title display
}) => {
  const { isMobile } = useAppContext();
  const { initLdsSupplements, ilsToUsd } = useSelectedResult();

  const {
    linkedFlights: linkedFlightsOrigin,
    availableFlights,
    savedDeal,
    setSavedDeal,
    initSupplements,
    supplements,
    selectedDepart,
    selectedReturn,
    setSelectedDepart,
    setSelectedReturn,
    calculatFlightLDSPrice,
    calculateLDSDealFare,
  } = useSearch();

  const linkedFlights = useMemo(() => {
    if (linkedFlightsData) return linkedFlightsData;
    return linkedFlightsOrigin;
  }, [linkedFlightsData, linkedFlightsOrigin]);

  const { t } = useTranslation();

  const [isSelectorOpen, setIsSelectorOpen] = useState(false);
  const [filter, setFilter] = useState(null);
  const [selectedLinkedFlightIndex, setSelectedLinkedFlightIndex] = useState(0);

  useEffect(() => {
    if (savedDeal) {
      initLdsSupplements(savedDeal, initSupplements ? undefined : supplements);
    }
  }, [initSupplements, supplements, savedDeal]);

  // Reset selected flight index when linkedFlights changes
  useEffect(() => {
    setSelectedLinkedFlightIndex(0);
  }, [linkedFlights]); // Compact render for dynamic packages

  // const renderCompactFlights = () => {
  //   // Handle different data structures
  //   let flightsToRender = null;

  //   if (linkedFlights) {
  //     if (Array.isArray(linkedFlights)) {
  //       flightsToRender = linkedFlights;
  //     } else if (linkedFlights.flight) {
  //       // Single flight object with flight property
  //       flightsToRender = linkedFlights.flight;
  //     } else {
  //       // Single flight object
  //       flightsToRender = [linkedFlights];
  //     }
  //   }

  //   if (
  //     !flightsToRender ||
  //     (Array.isArray(flightsToRender) && flightsToRender.length === 0)
  //   ) {
  //     return (
  //       <div className="compact-flights-empty">
  //         <Text type="secondary">{t("flights.noFlightsAvailable")}</Text>
  //       </div>
  //     );
  //   }

  //   return (
  //     <motion.div
  //       initial={{ opacity: 0 }}
  //       animate={{ opacity: 1 }}
  //       className="compact-flights-container"
  //     >
  //       {includeTitle ? (
  //         <div className="compact-flights-header">
  //           <Text strong className="compact-title">
  //             {t("flights.includedFlights")}
  //           </Text>
  //         </div>
  //       ) : null}
  //       <div className="compact-flights-list">
  //         {Array.isArray(flightsToRender) ? (
  //           flightsToRender.slice(0, 2).map((flight, index) => {
  //             // Handle different flight data structures
  //             let legs = [];
  //             if (flight && flight.leg) {
  //               legs = Array.isArray(flight.leg) ? flight.leg : [flight.leg];
  //             }

  //             return (
  //               <div key={index} className="compact-flight-item">
  //                 {legs.map((leg, legIndex) => {
  //                   if (!leg) return null;

  //                   const isOutbound = index === 0;
  //                   const depDate = leg.depDate
  //                     ? leg.depDate.split(" ")[1]
  //                     : "";
  //                   const arrDate = leg.arrDate
  //                     ? leg.arrDate.split(" ")[1]
  //                     : "";
  //                   const depDateString = leg.depDate
  //                     ? leg.depDate.split(" ")[0]
  //                     : "";
  //                   const arrDateString = leg.arrDate
  //                     ? leg.arrDate.split(" ")[0]
  //                     : "";

  //                   // Calculate duration display
  //                   const duration = leg.duration || 0;
  //                   const durationMin = duration % 60;
  //                   const durationHours = Math.floor(duration / 60);
  //                   const durationDisplay = `${durationHours}:${durationMin < 10 ? `0${durationMin}` : durationMin}`;

  //                   return (
  //                     <div key={legIndex} className="compact-flight-info">
  //                       <div className="flight-header">
  //                         <div className="flight-direction">
  //                           {isOutbound ? (
  //                             <>
  //                               <ArrowLeftOutlined /> טיסה הלוך
  //                             </>
  //                           ) : (
  //                             <>
  //                               <ArrowRightOutlined /> טיסה חזור
  //                             </>
  //                           )}
  //                         </div>
  //                         {/* Airline Details */}
  //                         <div className="flight-number">
  //                           {leg.flightNumber || ""}
  //                         </div>
  //                       </div>

  //                       <AirlineDisplay
  //                         airlineId={leg.airlineId}
  //                         flightNumber={leg.flightNumber}
  //                         isCompact={true}
  //                       />

  //                       <div
  //                         className={
  //                           "flight-route" + (!isOutbound ? " inbound" : "")
  //                         }
  //                       >
  //                         <div className="departure-info">
  //                           <div className="time">{depDate}</div>
  //                           <div className="date">{depDateString}</div>
  //                           <div className="airport">
  //                             {leg.depAirport?.code || leg.depCity || ""}
  //                           </div>
  //                         </div>

  //                         <div className="route-line">
  //                           <div className="duration-badge">
  //                             <ClockCircleOutlined />
  //                             {durationDisplay}
  //                           </div>
  //                           <div className="flight-path">
  //                             <div className="path-line"></div>
  //                             {isOutbound ? (
  //                               <ArrowLeftOutlined className="plane-icon" />
  //                             ) : (
  //                               <ArrowRightOutlined className="plane-icon" />
  //                             )}
  //                           </div>
  //                         </div>

  //                         <div className="arrival-info">
  //                           <div className="time">{arrDate}</div>
  //                           <div className="date">{arrDateString}</div>
  //                           <div className="airport">
  //                             {leg.arrAirport?.code || leg.arrCity || ""}
  //                           </div>
  //                         </div>
  //                       </div>

  //                       {leg.seats && (
  //                         <div className="flight-extras">
  //                           <span className="seats-info">
  //                             {leg.seats} מקומות זמינים
  //                           </span>
  //                         </div>
  //                       )}
  //                     </div>
  //                   );
  //                 })}
  //               </div>
  //             );
  //           })
  //         ) : (
  //           <div className="compact-flight-item">
  //             {(() => {
  //               // Handle single flight data structure
  //               let legs = [];
  //               if (flightsToRender && flightsToRender.leg) {
  //                 legs = Array.isArray(flightsToRender.leg)
  //                   ? flightsToRender.leg
  //                   : [flightsToRender.leg];
  //               }

  //               return legs.map((leg, legIndex) => {
  //                 if (!leg) return null;

  //                 const isOutbound = legIndex === 0;
  //                 const depDate = leg.depDate ? leg.depDate.split(" ")[1] : "";
  //                 const arrDate = leg.arrDate ? leg.arrDate.split(" ")[1] : "";
  //                 const depDateString = leg.depDate
  //                   ? leg.depDate.split(" ")[0]
  //                   : "";
  //                 const arrDateString = leg.arrDate
  //                   ? leg.arrDate.split(" ")[0]
  //                   : "";

  //                 // Calculate duration display
  //                 const duration = leg.duration || 0;
  //                 const durationMin = duration % 60;
  //                 const durationHours = Math.floor(duration / 60);
  //                 const durationDisplay = `${durationHours}:${durationMin < 10 ? `0${durationMin}` : durationMin}`;

  //                 return (
  //                   <div key={legIndex} className="compact-flight-info">
  //                     <div className="flight-header">
  //                       <div className="flight-direction">
  //                         {isOutbound ? (
  //                           <>
  //                             <ArrowLeftOutlined /> טיסה הלוך
  //                           </>
  //                         ) : (
  //                           <>
  //                             <ArrowRightOutlined /> טיסה חזור
  //                           </>
  //                         )}
  //                       </div>
  //                       <div className="flight-number">
  //                         {leg.flightNumber || ""}
  //                       </div>

  //                       {/* Seats and class info moved to header */}
  //                       <div className="flight-header-extras">
  //                         {leg.seats && (
  //                           <span className="seats-info">
  //                             {leg.seats} מקומות זמינים
  //                           </span>
  //                         )}
  //                         {leg.flightClass && (
  //                           <span className="flight-class-info">
  //                             {leg.flightClass}
  //                           </span>
  //                         )}
  //                       </div>
  //                     </div>

  //                     <div className="flight-route">
  //                       <div className="departure-info">
  //                         <div className="time">{depDate}</div>
  //                         <div className="date">{depDateString}</div>
  //                         <div className="airport">
  //                           {leg.depAirport?.code || leg.depCity || ""}
  //                         </div>
  //                       </div>

  //                       <div className="route-line">
  //                         <div className="duration-badge">
  //                           <ClockCircleOutlined />
  //                           {durationDisplay}
  //                         </div>
  //                         <div className="flight-path">
  //                           <div className="path-line"></div>
  //                           {isOutbound ? (
  //                             <ArrowLeftOutlined className="plane-icon" />
  //                           ) : (
  //                             <ArrowRightOutlined className="plane-icon" />
  //                           )}
  //                         </div>
  //                       </div>

  //                       <div className="arrival-info">
  //                         <div className="time">{arrDate}</div>
  //                         <div className="date">{arrDateString}</div>
  //                         <div className="airport">
  //                           {leg.arrAirport?.code || leg.arrCity || ""}
  //                         </div>
  //                       </div>
  //                     </div>

  //                     {/* Status remarks */}
  //                     {(leg.statusRemark || leg.flightCategory) && (
  //                       <div className="flight-status-compact">
  //                         <IoInformationCircleOutline size={12} />
  //                         <span className="status-text">
  //                           {leg.flightCategory || leg.statusRemark}
  //                         </span>
  //                       </div>
  //                     )}
  //                   </div>
  //                 );
  //               });
  //             })()}
  //           </div>
  //         )}
  //       </div>
  //     </motion.div>
  //   );
  // };

  const renderFlights = () => {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`flight-selection-container ${inTourObject ? "in-tour-object" : ""} ${isCompact ? "compact-mode" : ""}`}
      >
        {isCompact
          ? renderFlightsOnlyCompact(linkedFlights)
          : renderFlightsOnly(linkedFlights)}
        {(isSelectable &&
          Array.isArray(availableFlights) &&
          availableFlights.length - 1 > 0) ||
        (Array.isArray(linkedFlights) && linkedFlights.length > 1) ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3, duration: 0.3 }}
            className="tw-my-3"
          >
            <Button
              type="link"
              size="large"
              onClick={() => setIsSelectorOpen(true)}
            >
              {isSelectable &&
              Array.isArray(availableFlights) &&
              availableFlights.length - 1 > 0
                ? `${t("flights.viewMoreFlights")} (${availableFlights.length - 1})`
                : `${t("flights.viewMoreFlights")} (${linkedFlights.length - 1})`}
            </Button>
          </motion.div>
        ) : null}
        <AnimatePresence>
          {isSelectorOpen && (
            <motion.div
              className="flight-selector"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={() => setIsSelectorOpen(false)}
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.3 }}
                onClick={(e) => e.stopPropagation()}
              >
                <Card
                  className="flight-selector-card"
                  title={
                    <Space>
                      <SwitcherOutlined />
                      <span>{t("flights.changeFlights")}</span>
                    </Space>
                  }
                  styles={{
                    body: {
                      padding: "unset",
                    },
                  }}
                  extra={
                    <Button
                      type="text"
                      onClick={() => setIsSelectorOpen(false)}
                      className="tw-text-gray-500 hover:tw-text-gray-700"
                    >
                      ✕
                    </Button>
                  }
                >
                  <div
                    className="flight-options-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      maxHeight: isMobile ? "60vh" : "70vh",
                      overflowY: "auto",
                      padding: "15px",
                      width: "calc(100% - 30px)",
                    }}
                  >
                    {/* Show availableFlights if it's a selectable context with multiple deals */}
                    {isSelectable &&
                    Array.isArray(availableFlights) &&
                    availableFlights.length > 1
                      ? availableFlights
                          .sort((a, b) => {
                            const aPrice = calculatFlightLDSPrice(a);
                            const bPrice = calculatFlightLDSPrice(b);
                            return aPrice - bPrice;
                          })
                          .map((deal, index) => {
                            const price = calculateLDSDealFare(deal);
                            const total_fare =
                              price.ourTotalFare
                                ?.priceWithCommissionAndCreditCardFee || 0;
                            return (
                              <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                  duration: 0.3,
                                  delay: index * 0.1,
                                }}
                              >
                                <Card
                                  hoverable
                                  className={`flight-option-card ${
                                    index === 0 ? "best-price-card" : ""
                                  }`}
                                  styles={{
                                    body: { padding: "20px" },
                                  }}
                                >
                                  <div className="flight-option-content">
                                    {isCompact
                                      ? renderFlightsOnlyCompact(
                                          deal.linkedFlights
                                        )
                                      : renderFlightsOnly(deal.linkedFlights)}
                                  </div>

                                  <Divider className="tw-my-4" />

                                  <div className="flight-option-footer">
                                    <div className="price-section">
                                      <motion.div
                                        className="price-display"
                                        whileHover={{ scale: 1.02 }}
                                        transition={{ duration: 0.2 }}
                                      >
                                        <Text
                                          className="price-amount"
                                          onClick={() => {
                                            // Add price highlight animation on click
                                            const element =
                                              document.querySelector(
                                                `.flight-option-card:nth-child(${index + 1}) .price-amount`
                                              );
                                            if (element) {
                                              element.classList.add(
                                                "price-highlight-animation"
                                              );
                                              setTimeout(() => {
                                                element.classList.remove(
                                                  "price-highlight-animation"
                                                );
                                              }, 800);
                                            }
                                          }}
                                        >
                                          {convertPrice(total_fare)}
                                        </Text>
                                        <Text className="price-usd">
                                          ({ilsToUsd(total_fare)}$)
                                        </Text>{" "}
                                        {index === 0 ? (
                                          <Badge
                                            count={t("flights.bestPrice")}
                                            color="green"
                                            className="price-badge"
                                          />
                                        ) : null}
                                      </motion.div>
                                    </div>
                                    <motion.div
                                      className="motion-wrapper"
                                      whileHover={{ scale: 1.05 }}
                                      whileTap={{ scale: 0.95 }}
                                      transition={{ duration: 0.2 }}
                                    >
                                      <Button
                                        type="primary"
                                        icon={<CheckCircleOutlined />}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSavedDeal(deal);
                                          setIsSelectorOpen(false);
                                        }}
                                        className="choose-flight-btn"
                                      >
                                        {t("flights.chooseFlight")}
                                      </Button>
                                    </motion.div>
                                  </div>
                                </Card>
                              </motion.div>
                            );
                          })
                      : /* Show linkedFlights when there are multiple linked flights but no availableFlights */
                        Array.isArray(linkedFlights) && linkedFlights.length > 1
                        ? linkedFlights.map((linkedFlight, index) => {
                            return (
                              <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                  duration: 0.3,
                                  delay: index * 0.1,
                                }}
                              >
                                <Card
                                  hoverable
                                  className={`flight-option-card ${
                                    index === selectedLinkedFlightIndex
                                      ? "selected-flight-card"
                                      : ""
                                  }`}
                                  styles={{
                                    body: { padding: "20px" },
                                  }}
                                >
                                  <div className="flight-option-content">
                                    {isCompact
                                      ? renderFlightsOnlyCompact(linkedFlight)
                                      : renderFlightsOnly(linkedFlight)}
                                  </div>

                                  <Divider className="tw-my-4" />

                                  <div className="flight-option-footer">
                                    <motion.div
                                      className="motion-wrapper"
                                      whileHover={{ scale: 1.05 }}
                                      whileTap={{ scale: 0.95 }}
                                      transition={{ duration: 0.2 }}
                                    >
                                      <Button
                                        type={
                                          index === selectedLinkedFlightIndex
                                            ? "primary"
                                            : "default"
                                        }
                                        icon={
                                          index ===
                                          selectedLinkedFlightIndex ? (
                                            <CheckCircleOutlined />
                                          ) : null
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedLinkedFlightIndex(index);
                                          setIsSelectorOpen(false);
                                        }}
                                        className="choose-flight-btn"
                                      >
                                        {index === selectedLinkedFlightIndex
                                          ? t("flights.selected", "נבחר")
                                          : t("flights.chooseFlight")}
                                      </Button>
                                    </motion.div>
                                  </div>
                                </Card>
                              </motion.div>
                            );
                          })
                        : null}
                  </div>
                </Card>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    );
  };

  // Fix: Avoid setState in render, move to useEffect
  useEffect(() => {
    if (
      Array.isArray(linkedFlights) &&
      linkedFlights.length > 0 &&
      linkedFlights[selectedLinkedFlightIndex] &&
      linkedFlights[selectedLinkedFlightIndex].flight &&
      linkedFlights[selectedLinkedFlightIndex].flight[0] &&
      linkedFlights[selectedLinkedFlightIndex].flight[1]
    ) {
      setSelectedDepart(linkedFlights[selectedLinkedFlightIndex].flight[0].leg);
      setSelectedReturn(linkedFlights[selectedLinkedFlightIndex].flight[1].leg);
    }
    // Only run when linkedFlights, selectedLinkedFlightIndex or selectedDepart/selectedReturn change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    linkedFlights,
    selectedLinkedFlightIndex,
    setSelectedDepart,
    setSelectedReturn,
  ]);

  const renderFlightsOnly = (linkedFlights) => {
    if (linkedFlights === null) return null;

    if (Array.isArray(linkedFlights)) {
      // Don't render until selectedDepart and selectedReturn are set
      if (selectedDepart === null || selectedReturn === null) {
        return null;
      }

      // Filter flights based on the selected linked flight index
      const currentLinkedFlight =
        linkedFlights[selectedLinkedFlightIndex] || linkedFlights[0];
      const currentFlights = [currentLinkedFlight];

      const departFlights = currentFlights
        .map((linkedFlight, index) => {
          return linkedFlight.flight[0].leg;
        })
        .reduce((acc, curr) => {
          if (acc.findIndex((item) => item.depDate === curr.depDate) === -1) {
            acc.push(curr);
          }
          return acc;
        }, []);

      const returnFlights = currentFlights
        .map((linkedFlight, index) => {
          return linkedFlight.flight[1].leg;
        })
        .reduce((acc, curr) => {
          if (acc.findIndex((item) => item.depDate === curr.depDate) === -1) {
            acc.push(curr);
          }
          return acc;
        }, []);

      const departs = departFlights.map((leg, index) => {
        return {
          label: (
            <Space>
              <ClockCircleOutlined />
              <span>{leg.depDate.split(" ")[1]}</span>
            </Space>
          ),
          key: index.toString(),
          children: (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <FlightFooterRow
                key={index}
                flight={leg}
                title={t("packages.firstWayFlight")}
              />
            </motion.div>
          ),
        };
      });

      const returns = returnFlights.map((leg, index) => {
        const isDisabled =
          !selectedDepart ||
          currentFlights.findIndex(
            (linkedFlight) =>
              linkedFlight.flight[1].leg.depDate === leg.depDate &&
              linkedFlight.flight[0].leg.depDate === selectedDepart.depDate
          ) === -1;

        return {
          label: (
            <Space>
              <ClockCircleOutlined />
              <span>{leg.depDate.split(" ")[1]}</span>
            </Space>
          ),
          key: index.toString(),
          children: (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <FlightFooterRow
                key={index}
                flight={leg}
                title={t("packages.returnFlight")}
              />
            </motion.div>
          ),
          disabled: isDisabled,
        };
      });

      if (loadingLinkedFlights) {
        return (
          <motion.div
            className="skeleton-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Skeleton active paragraph={{ rows: 4 }} className="tw-w-full" />
          </motion.div>
        );
      }

      return (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flights-tabs-container"
        >
          {/* Flight Selection Dropdown - Only show if there are multiple flights */}
          {linkedFlights.length > 1 && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="flight-selector-dropdown tw-mb-4"
            >
              <div className="tw-flex tw-items-center tw-gap-3">
                <Text strong className="tw-text-gray-700">
                  {t("flights.selectFlightOption", "בחר אפשרות טיסה:")}
                </Text>
                <Select
                  value={selectedLinkedFlightIndex}
                  onChange={setSelectedLinkedFlightIndex}
                  className="tw-min-w-48"
                  size="large"
                >
                  {linkedFlights.map((linkedFlight, index) => {
                    const departLeg = linkedFlight.flight[0].leg;
                    const returnLeg = linkedFlight.flight[1].leg;
                    const departTime = departLeg.depDate
                      ? departLeg.depDate.split(" ")[1]
                      : "";
                    const returnTime = returnLeg.depDate
                      ? returnLeg.depDate.split(" ")[1]
                      : "";

                    return (
                      <Select.Option key={index} value={index}>
                        <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                          <span>
                            {t("flights.option", "אפשרות")} {index + 1}
                          </span>
                          <span className="tw-text-xs tw-text-gray-500">
                            {departTime} → {returnTime}
                          </span>
                        </div>
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
            </motion.div>
          )}

          {/* Departure Section */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="flight-section departure-section"
          >
            <div className="section-header">
              <div className="section-icon">
                <ArrowLeftOutlined className="tw-text-blue-600" />
              </div>
              <Title level={4} className="section-title tw-mb-0">
                <span>טיסה הלוך</span>
              </Title>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
            >
              <Tabs
                key="departs"
                items={departs}
                activeKey={departFlights
                  .findIndex(
                    (depart) => depart.depDate === selectedDepart.depDate
                  )
                  .toString()}
                onChange={(key) => {
                  const depart = departFlights[Number(key)];
                  if (
                    !!selectedDepart &&
                    selectedDepart.depDate === depart.depDate
                  )
                    return;
                  const flightIndex = currentFlights.findIndex(
                    (linkedFlight) =>
                      linkedFlight.flight[0].leg.depDate === depart.depDate
                  );
                  const returnFlight =
                    currentFlights[flightIndex].flight[1].leg;
                  setSelectedDepart(depart);
                  setSelectedReturn(returnFlight);
                }}
                className="flight-tabs"
                size="large"
              />
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scaleX: 0 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 0.4, delay: 0.3 }}
          >
            <Divider className="section-divider" />
          </motion.div>

          {/* Return Section */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="flight-section return-section"
          >
            <div className="section-header">
              <div className="section-icon">
                {<ArrowRightOutlined className="tw-text-green-600" />}
              </div>
              <Title level={4} className="section-title tw-mb-0">
                <span>טיסה חזור</span>
              </Title>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.5 }}
            >
              <Tabs
                key="returns"
                items={returns}
                activeKey={returnFlights
                  .findIndex(
                    (returnFlight) =>
                      returnFlight.depDate === selectedReturn.depDate
                  )
                  .toString()}
                onChange={(key) => {
                  const flight = returnFlights[Number(key)];
                  if (
                    !!selectedReturn &&
                    selectedReturn.depDate === flight.depDate
                  )
                    return;
                  setSelectedReturn(flight);
                }}
                className="flight-tabs"
                size="large"
              />
            </motion.div>
          </motion.div>
        </motion.div>
      );
    } else {
      return (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <FlightsFooter flights={linkedFlights?.flight} />
        </motion.div>
      );
    }
  };

  const renderFlightsOnlyCompact = (linkedFlights) => {
    // Handle different data structures for linked flights
    let flightsToRender = null;

    if (linkedFlights) {
      if (Array.isArray(linkedFlights)) {
        // Array of linked flights - use selected index or first one for compact display
        const selectedFlight =
          linkedFlights[selectedLinkedFlightIndex] || linkedFlights[0];
        flightsToRender = selectedFlight?.flight || linkedFlights;
      } else if (linkedFlights.flight) {
        // Single flight object with flight property
        flightsToRender = linkedFlights.flight;
      } else {
        // Single flight object
        flightsToRender = [linkedFlights];
      }
    }

    if (
      !flightsToRender ||
      (Array.isArray(flightsToRender) && flightsToRender.length === 0)
    ) {
      return (
        <div className="compact-flights-empty">
          <Text type="secondary">{t("flights.noFlightsAvailable")}</Text>
        </div>
      );
    }

    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="compact-flights-container"
      >
        {/* Compact Flight Selection Dropdown - Only show if there are multiple flights */}
        {/* {Array.isArray(linkedFlights) && linkedFlights.length > 1 && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="compact-flight-selector tw-mb-3"
          >
            <Select
              value={selectedLinkedFlightIndex}
              onChange={setSelectedLinkedFlightIndex}
              className="tw-w-full"
              size="small"
              placeholder={t("flights.selectFlightOption", "בחר אפשרות טיסה")}
            >
              {linkedFlights.map((linkedFlight, index) => {
                const departLeg = linkedFlight.flight[0].leg;
                const returnLeg = linkedFlight.flight[1].leg;
                const departTime = departLeg.depDate
                  ? departLeg.depDate.split(" ")[1]
                  : "";
                const returnTime = returnLeg.depDate
                  ? returnLeg.depDate.split(" ")[1]
                  : "";

                return (
                  <Select.Option key={index} value={index}>
                    <div className="tw-flex tw-items-center tw-justify-between">
                      <span className="tw-text-xs">
                        {t("flights.option", "אפשרות")} {index + 1}
                      </span>
                      <span className="tw-text-xs tw-text-gray-500">
                        {departTime} → {returnTime}
                      </span>
                    </div>
                  </Select.Option>
                );
              })}
            </Select>
          </motion.div>
        )} */}

        <div className="compact-flights-list">
          {Array.isArray(flightsToRender) ? (
            flightsToRender.slice(0, 2).map((flight, index) => {
              // Handle different flight data structures
              let legs = [];
              if (flight && flight.leg) {
                legs = Array.isArray(flight.leg) ? flight.leg : [flight.leg];
              }

              return (
                <div key={index} className="compact-flight-item">
                  {legs.map((leg, legIndex) => {
                    if (!leg) return null;

                    const isOutbound = index === 0;
                    const depDate = leg.depDate
                      ? leg.depDate.split(" ")[1]
                      : "";
                    const arrDate = leg.arrDate
                      ? leg.arrDate.split(" ")[1]
                      : "";
                    const depDateString = leg.depDate
                      ? leg.depDate.split(" ")[0]
                      : "";
                    const arrDateString = leg.arrDate
                      ? leg.arrDate.split(" ")[0]
                      : "";

                    // Calculate duration display
                    const duration = leg.duration || 0;
                    const durationMin = duration % 60;
                    const durationHours = Math.floor(duration / 60);
                    const durationDisplay = `${durationHours}:${durationMin < 10 ? `0${durationMin}` : durationMin}`;

                    return (
                      <div key={legIndex} className="compact-flight-info">
                        <div className="flight-header">
                          <div className="flight-direction">
                            {isOutbound ? (
                              <>
                                <ArrowLeftOutlined /> טיסה הלוך
                              </>
                            ) : (
                              <>
                                <ArrowRightOutlined /> טיסה חזור
                              </>
                            )}
                          </div>
                          {/* Seats and class info moved to header */}
                          <div className="flight-header-extras">
                            <div className="flight-number">
                              {leg.flightNumber || ""}
                            </div>
                            {leg.flightClass && (
                              <span className="flight-class-info">
                                {leg.flightClass}
                              </span>
                            )}
                            {leg.seats && (
                              <span className="seats-info">
                                {leg.seats} מקומות זמינים
                              </span>
                            )}
                          </div>
                        </div>

                        <AirlineDisplay
                          airlineId={leg.airlineId}
                          flightNumber={leg.flightNumber}
                          isCompact={true}
                        />

                        <div
                          className={
                            "flight-route" + (!isOutbound ? " inbound" : "")
                          }
                        >
                          <div className="departure-info">
                            <div className="time">{depDate}</div>
                            <div className="date">{depDateString}</div>
                            <div className="airport">
                              {leg.depAirport?.code || leg.depCity || ""}
                            </div>
                          </div>
                          <div className="route-line">
                            <div className="duration-badge">
                              <ClockCircleOutlined />
                              {durationDisplay}
                            </div>
                            <div className="flight-path">
                              <div className="path-line"></div>
                              {isOutbound ? (
                                <FaPlane
                                  className="plane-icon"
                                  style={{ transform: "scaleX(-1)" }}
                                />
                              ) : (
                                <FaPlane className="plane-icon" />
                              )}
                            </div>
                          </div>
                          <div className="arrival-info">
                            <div className="time">{arrDate}</div>
                            <div className="date">{arrDateString}</div>
                            <div className="airport">
                              {leg.arrAirport?.code || leg.arrCity || ""}{" "}
                            </div>
                          </div>{" "}
                        </div>

                        {/* Flight extras - luggage and status info */}
                        <div className="flight-extras">
                          {/* Compact luggage info */}
                          {Number(leg.maxHandLuggageWeight) > 0 ||
                          Number(leg.maxCheckedLuggageWeight) > 0 ? (
                            <div className="compact-luggage-info">
                              {/* Hand luggage */}
                              {Number(leg.maxHandLuggageWeight) > 0 && (
                                <div className="luggage-item hand-luggage">
                                  <SlHandbag size={12} />
                                  <span>{leg.maxHandLuggageWeight} ק"ג</span>
                                </div>
                              )}

                              {/* Checked luggage */}
                              {Number(leg.maxCheckedLuggageWeight) > 0 && (
                                <div className="luggage-item checked-luggage">
                                  <PiSuitcaseRolling size={12} />
                                  <span>{leg.maxCheckedLuggageWeight} ק"ג</span>
                                </div>
                              )}
                            </div>
                          ) : null}

                          {/* Status remarks */}
                          {leg.flightCategory && (
                            <div className="flight-status-compact">
                              <IoInformationCircleOutline size={12} />
                              <span className="status-text">
                                {leg.flightCategory}
                              </span>
                            </div>
                          )}

                          {/* Status remarks */}
                          {leg.statusRemark && (
                            <Tooltip title={leg.statusRemark}>
                              <div className="flight-status-compact">
                                <IoInformationCircleOutline size={12} />
                                <span className="status-text">
                                  {leg.statusRemark}
                                </span>
                              </div>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })
          ) : (
            <div className="compact-flight-item">
              {(() => {
                // Handle single flight data structure
                let legs = [];
                if (flightsToRender && flightsToRender.leg) {
                  legs = Array.isArray(flightsToRender.leg)
                    ? flightsToRender.leg
                    : [flightsToRender.leg];
                }

                return legs.map((leg, legIndex) => {
                  if (!leg) return null;

                  const isOutbound = legIndex === 0;
                  const depDate = leg.depDate ? leg.depDate.split(" ")[1] : "";
                  const arrDate = leg.arrDate ? leg.arrDate.split(" ")[1] : "";
                  const depDateString = leg.depDate
                    ? leg.depDate.split(" ")[0]
                    : "";
                  const arrDateString = leg.arrDate
                    ? leg.arrDate.split(" ")[0]
                    : "";

                  // Calculate duration display
                  const duration = leg.duration || 0;
                  const durationMin = duration % 60;
                  const durationHours = Math.floor(duration / 60);
                  const durationDisplay = `${durationHours}:${durationMin < 10 ? `0${durationMin}` : durationMin}`;

                  return (
                    <div key={legIndex} className="compact-flight-info">
                      <div className="flight-header">
                        <div className="flight-direction">
                          {isOutbound ? (
                            <>
                              <ArrowLeftOutlined /> טיסה הלוך
                            </>
                          ) : (
                            <>
                              <ArrowRightOutlined /> טיסה חזור
                            </>
                          )}
                        </div>
                        <div className="flight-number">
                          {leg.flightNumber || ""}
                        </div>

                        {/* Seats and class info moved to header */}
                        <div className="flight-header-extras">
                          {leg.seats && (
                            <span className="seats-info">
                              {leg.seats} מקומות זמינים
                            </span>
                          )}
                          {leg.flightClass && (
                            <span className="flight-class-info">
                              {leg.flightClass}
                            </span>
                          )}
                        </div>
                      </div>

                      <AirlineDisplay
                        airlineId={leg.airlineId}
                        flightNumber={leg.flightNumber}
                        isCompact={true}
                      />

                      <div className="flight-route">
                        <div className="departure-info">
                          <div className="time">{depDate}</div>
                          <div className="date">{depDateString}</div>
                          <div className="airport">
                            {leg.depAirport?.code || leg.depCity || ""}
                          </div>
                        </div>
                        <div className="route-line">
                          <div className="duration-badge">
                            <ClockCircleOutlined />
                            {durationDisplay}
                          </div>
                          <div className="flight-path">
                            <div className="path-line"></div>
                            {isOutbound ? (
                              <FaPlane
                                className="plane-icon"
                                style={{ transform: "scaleX(-1)" }}
                              />
                            ) : (
                              <FaPlane className="plane-icon" />
                            )}
                          </div>
                        </div>
                        <div className="arrival-info">
                          <div className="time">{arrDate}</div>
                          <div className="date">{arrDateString}</div>
                          <div className="airport">
                            {leg.arrAirport?.code || leg.arrCity || ""}
                          </div>{" "}
                        </div>{" "}
                      </div>

                      {/* Flight extras - luggage and status info */}
                      <div className="flight-extras">
                        {/* Compact luggage info */}
                        <div className="compact-luggage-info">
                          {/* Hand luggage */}
                          {leg.maxHandLuggageWeight && (
                            <div className="luggage-item hand-luggage">
                              <SlHandbag size={12} />
                              <span>{leg.maxHandLuggageWeight} ק"ג</span>
                            </div>
                          )}

                          {/* Checked luggage */}
                          {leg.maxCheckedLuggageWeight && (
                            <div className="luggage-item checked-luggage">
                              <PiSuitcaseRolling size={12} />
                              <span>{leg.maxCheckedLuggageWeight} ק"ג</span>
                            </div>
                          )}
                        </div>

                        {/* Status remarks */}
                        {(leg.statusRemark || leg.flightCategory) && (
                          <div className="flight-status-compact">
                            <IoInformationCircleOutline size={12} />
                            <span className="status-text">
                              {leg.flightCategory || leg.statusRemark}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          )}
        </div>
      </motion.div>
    );
  };

  const flightSelectionCollapsed = [
    {
      key: "1",
      label: "טיסות",
      children: renderFlights(),
    },
  ];

  if (isCollaped || isCard)
    return (
      <ConfigProvider
        theme={{
          components: {
            Collapse: {
              headerBg: "#0258a4",
              colorTextHeading: "#ffffff",
            },
          },
        }}
      >
        {isCollaped ? (
          <Collapse
            style={{
              width: "100%",
            }}
            items={flightSelectionCollapsed}
            dir="rtl"
            defaultActiveKey={["1"]}
          />
        ) : (
          <Card
            title={title}
            style={{
              width: "100%",
              borderRadius: "10px",
            }}
            styles={{
              body: {
                padding: "10px",
                display: "flex",
                flexDirection: "row",
                width: "100%",
                gap: "10px",
                flexWrap: "wrap",
              },
              header: {
                padding: "10px",
                fontSize: "1rem",
                fontWeight: "bold",
                color: "#0258a4",
                minHeight: "unset",
              },
              title: {
                textOverflow: "unset",
                whiteSpace: "unset",
              },
            }}
          >
            {renderFlights()}
          </Card>
        )}
      </ConfigProvider>
    );

  return renderFlights();
};

export default FlightSelection;
